// Professional easing curves
export const EASING_CURVES = {
  EASE_OUT_QUART: [0.165, 0.84, 0.44, 1],
  EASE_OUT_FADE_COLLAPSE: [0.4, 0, 0.2, 1],
  EASE_OUT_SMOOTH: [0.25, 0.46, 0.45, 0.94],
} as const

// Loading animation timing constants
export const LOADING_ANIMATION_TIMING = {
  FADE_OUT_TRANSITION: 300,
  SKELETON_DURATION: 2000,
  DIGIT_CHANGE_INTERVAL: 300,
  CHART_SKELETON_UPDATE: 100,
  SEGMENT_CHART_DURATION: 2000,
  DIGIT_ANIMATION_DURATION: 2000,
  STAT_CARD_DIGIT_INTERVAL: 1200,
  STAT_CARD_DURATION: 4000,
  // Bar chart skeleton specific timings
  BAR_SKELETON_ANIMATE_DURATION: 0.4,
  BAR_SKELETON_STAGGER_DELAY: 0.1,
  BAR_SKELETON_GLOW_DURATION: 3,
  BAR_SKELETON_GLOW_STAGGER: 0.3,
} as const

// Loading animation types
export enum LoadingAnimationType {
  NONE = 'none',
  SKELETON = 'skeleton',
  DIGIT = 'digit',
  WAVE = 'wave',
  PULSE = 'pulse',
}

// Data display types for consistent formatting
export enum DataDisplayType {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
  DECIMAL = 'decimal',
  INTEGER = 'integer',
  YEAR = 'year',
}
